<script lang="ts">
  import RulesManager from './RulesManager.svelte';
  import CategoriesTab from './settings/CategoriesTab.svelte';
  import DataManagementTab from './settings/DataManagementTab.svelte';
  import LLMSettingsTab from './settings/LLMSettingsTab.svelte';
  import PreferencesTab from './settings/PreferencesTab.svelte';
  import { getStorage } from '../lib/storage';

  let {
    onUpdate = () => {},
    onClearAllData = () => {}
  }: {
    onUpdate: () => void;
    onClearAllData: () => void;
  } = $props();

  const storage = getStorage();

  // Persist active tab in storage so it survives data reloads
  let activeTab = $state(storage.getUIState('settings_active_tab') || 'preferences');

  // Save active tab to storage whenever it changes
  $effect(() => {
    storage.setUIState('settings_active_tab', activeTab);
  });
</script>

<div class="settings-page">

  <div class="tabs">
    <button
      class:active={activeTab === 'preferences'}
      onclick={() => activeTab = 'preferences'}
    >
      Preferences
    </button>
    <button
      class:active={activeTab === 'categories'}
      onclick={() => activeTab = 'categories'}
    >
      Categories
    </button>
    <button
      class:active={activeTab === 'rules'}
      onclick={() => activeTab = 'rules'}
    >
      Rules
    </button>
    <button
      class:active={activeTab === 'ai'}
      onclick={() => activeTab = 'ai'}
    >
      AI Categorization
    </button>
    <button
      class:active={activeTab === 'data'}
      onclick={() => activeTab = 'data'}
    >
      Data Management
    </button>
  </div>

  <div class="tab-content">
    {#if activeTab === 'preferences'}
      <PreferencesTab />
    {:else if activeTab === 'categories'}
      <CategoriesTab {onUpdate} />
    {:else if activeTab === 'rules'}
      <RulesManager {onUpdate} />
    {:else if activeTab === 'ai'}
      <LLMSettingsTab {onUpdate} />
    {:else if activeTab === 'data'}
      <DataManagementTab onUploadComplete={onUpdate} {onClearAllData} />
    {/if}
  </div>
</div>

<style lang="scss">
  .settings-page {
    max-width: calc(100vw - var(--sidebar-width));
    margin: 0 auto;
  }

  .page-header {
    margin-bottom: var(--spacing-2xl);

    h1 {
      font-size: var(--font-size-4xl);
      font-weight: var(--font-weight-semibold);
      color: var(--color-text-primary);
      margin: 0;
    }
  }

  .tabs {
    display: flex;
    gap: var(--spacing-xs);
    border-bottom: var(--border-width-thin) solid var(--color-border);
    margin-bottom: var(--spacing-2xl);
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;

    button {
      padding: var(--spacing-md) var(--spacing-xl);
      background: none;
      border: none;
      border-bottom: var(--border-width-medium) solid transparent;
      cursor: pointer;
      font-size: var(--font-size-base);
      font-weight: var(--font-weight-medium);
      color: var(--color-text-tertiary);
      transition: all var(--transition-fast);
      position: relative;
      top: 1px;
      white-space: nowrap;

      &:hover {
        color: var(--color-text-primary);
      }

      &.active {
        color: var(--color-primary);
        border-bottom-color: var(--color-primary);
      }
    }
  }

  .tab-content {
    animation: fadeIn 0.2s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

 

  @media (max-width: 768px) {
    .page-header {
      margin-bottom: var(--spacing-xl);

      h1 {
        font-size: var(--font-size-3xl);
      }
    }

    .tabs {
      gap: var(--spacing-xs);
      margin-bottom: var(--spacing-xl);

      button {
        padding: var(--spacing-sm) var(--spacing-md);
        font-size: var(--font-size-sm);
      }
    }
  }

  @media (max-width: 640px) {
    .settings-page {
      padding: var(--spacing-md);
    }

    .page-header {
      h1 {
        font-size: var(--font-size-2xl);
      }
    }

    .tabs {
      button {
        padding: var(--spacing-sm);
        font-size: var(--font-size-xs);
      }
    }
  }
</style>
